/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import {useTranslation} from 'react-i18next';

import PortalSelectController from '../../portalSelect/portalSelectController';

import {COUNTRIES} from '../../../../util/countryUtil';

// Country stored by NAME (CountryField labelAsValue parity — same convention
// as the Advanced-search country filter).
const countryItems = Object.values(COUNTRIES).map((name: string) => ({label: name, value: name}));

interface Props {
    onChange: (value: string) => void;
    value: string;
    label?: string;
    disabled?: boolean;
    itemsHeight?: number | string;
}

/**
 * Portal-select country picker in the rounded/uniform dialog convention.
 * Values are country NAMES (parity with CountryField's labelAsValue mode).
 */
export default function BolmateCountrySelect(props: Props) {
    const {t} = useTranslation();
    const {onChange, value, label, disabled, itemsHeight = '20rem'} = props;

    return (
        <PortalSelectController
            onChange={(next: string | null) => onChange(next ?? '')}
            value={value}
            items={countryItems}
            label={label ?? `${t('controls.countryField.country', 'Land')} *`}
            shape='rounded'
            uniformFont
            noShadow
            disabled={disabled}
            itemsHeight={itemsHeight}
        />
    );
}
